module.exports = __webpack_public_path__ + "img/tu_file_pdf.fd7c45aa.svg";